import React, { useState } from 'react'
import { ModalWrapper, SelectField, StyledButton } from '../../../../../../components'
import { Typography } from '@mui/material'
import { SuccesAnimation } from '../../../../../../assets/images'

const SetAdmin = ({ open, handleClose }) => {
  const [addAdmin, setAddAdmin] = useState(false)

  const handleAddAdmin = () => {
    setAddAdmin(true)
  }
  const selectOptions = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
  ]
  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      title={'Set Admin'}
      width={'315px'}
      adminAdd={addAdmin}
    >
      {!addAdmin && (
        <div>
          <SelectField label={'School'} options={selectOptions} />
          <SelectField label={'Employee'} options={selectOptions} />
          <div className="in-a-row">
            <Typography className="cancel-btn">Cancel</Typography>
            <StyledButton onClick={handleAddAdmin}>Add</StyledButton>
          </div>
        </div>
      )}
      {addAdmin && (
        <div className="admin-added">
          <img src={SuccesAnimation} alt="" className="success-animation" />
          <Typography fontSize={'24px'} fontWeight={700}>
            Admin Added!
          </Typography>
          <Typography fontSize={'16px'}>
            Your account setup is finished, making it simple to monitor student attendance
            effortlessly.
          </Typography>
          <div className="admin-info">
            <Typography className="admin-i-title">School</Typography>
            <Typography className="admin-i-value">Don Bosco</Typography>

            <Typography className="admin-i-title">Employee</Typography>
            <Typography className="admin-i-value">John</Typography>
          </div>
          <StyledButton onClick={handleClose}>Okay</StyledButton>
        </div>
      )}
    </ModalWrapper>
  )
}

export default SetAdmin
